<!-- src/components/LucideIcon.vue -->
<template>
  <component
    :is="iconComponent"
    :size="size"
    :color="color"
    :stroke-width="strokeWidth"
    :class="iconClass"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import * as icons from 'lucide-vue'

export default {
  name: 'LucideIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    strokeWidth: {
      type: [String, Number],
      default: 2
    },
    iconClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  computed: {
    iconComponent() {
      return icons[this.name] || null
    }
  }
}
</script>
